import { j as o } from "../../../jsx-runtime-82a9ddf6.js";
const i = ({ width: r = 20, height: t = 20, className: e, style: n }) => /* @__PURE__ */ o.jsxs(
  "svg",
  {
    width: r,
    height: t,
    className: e,
    style: n,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M4.16675 10H15.8334",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M10.8333 15L15.8333 10",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ o.jsx(
        "path",
        {
          d: "M10.8333 5L15.8333 10",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
);
export {
  i as ComplexArrowRightIcon
};
